import { render, staticRenderFns } from "./AdminAgentSessionQA.vue?vue&type=template&id=1f5c966a&scoped=true"
import script from "./AdminAgentSessionQA.vue?vue&type=script&lang=js"
export * from "./AdminAgentSessionQA.vue?vue&type=script&lang=js"
import style0 from "./AdminAgentSessionQA.vue?vue&type=style&index=0&id=1f5c966a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c966a",
  null
  
)

export default component.exports